export default __webpack_public_path__ + "static/pointing-86e1a02e09c670134bb3bbada3f0ebf5.png";